@if (url(); as url) {
  <img class="logo" [src]="url" [alt]="name()" (error)="onError()" />
} @else {
  <svg
    class="logo logo--initial"
    viewBox="0 0 100 100"
    role="img"
    [attr.aria-label]="name()"
  >
    <rect width="100" height="100" rx="22" [attr.fill]="background()" />
    <text
      x="50"
      y="50"
      dy="0.35em"
      text-anchor="middle"
      font-size="54"
      font-weight="600"
      [attr.fill]="foreground()"
    >{{ initial() }}</text>
  </svg>
}
